import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import logoWithText from "../images/text-logo.png"

const Header = ({ siteTitle }) => (
  <header>
    <Link to="/" style={{ display: "block", height: "5vh" }}>
      <img alt="logo" src={logoWithText} style={{ height: "100%" }} />
    </Link>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
